var fn = function fn($window, phonePortraitMediaBreakpoint, phoneLandscapeMediaBreakpoint, tabletPortraitMediaBreakpoint, tabletLandscapeMediaBreakpoint, desktopSmallMediaBreakpoint) {
    return {
        // check if meets specific size
        getPhonePortraitOnlyQuery: function getPhonePortraitOnlyQuery() {
            return $window.matchMedia('(max-width: ' + phonePortraitMediaBreakpoint + 'px)');
        },
        getPhoneLandscapeOnlyQuery: function getPhoneLandscapeOnlyQuery() {
            return $window.matchMedia('(min-width: ' + (phonePortraitMediaBreakpoint + 1) + 'px) and (max-width: ' + phoneLandscapeMediaBreakpoint + 'px)');
        },
        getTabletPortraitOnlyQuery: function getTabletPortraitOnlyQuery() {
            return $window.matchMedia('(min-width: ' + (phoneLandscapeMediaBreakpoint + 1) + 'px) and (max-width: ' + tabletPortraitMediaBreakpoint + 'px)');
        },
        getTabletLandscapeOnlyQuery: function getTabletLandscapeOnlyQuery() {
            return $window.matchMedia('(min-width: ' + (tabletPortraitMediaBreakpoint + 1) + 'px) and (max-width: ' + tabletLandscapeMediaBreakpoint + 'px)');
        },
        getDesktopSmallOnlyQuery: function getDesktopSmallOnlyQuery() {
            return $window.matchMedia('(min-width: ' + (tabletLandscapeMediaBreakpoint + 1) + 'px) and (max-width: ' + desktopSmallMediaBreakpoint + 'px)');
        },
        getDesktopLargeOnlyQuery: function getDesktopLargeOnlyQuery() {
            return $window.matchMedia('(min-width: ' + (desktopSmallMediaBreakpoint + 1) + 'px)');
        },
        // check if size is smaller or equal to the specified one
        getPhonePortraitDownQuery: function getPhonePortraitDownQuery() {
            return $window.matchMedia('(max-width: ' + phonePortraitMediaBreakpoint + 'px)');
        },
        getPhoneLandscapeDownQuery: function getPhoneLandscapeDownQuery() {
            return $window.matchMedia('(max-width: ' + phoneLandscapeMediaBreakpoint + 'px)');
        },
        getTabletPortraitDownQuery: function getTabletPortraitDownQuery() {
            return $window.matchMedia('(max-width: ' + tabletPortraitMediaBreakpoint + 'px)');
        },
        getTabletLandscapeDownQuery: function getTabletLandscapeDownQuery() {
            return $window.matchMedia('(max-width: ' + tabletLandscapeMediaBreakpoint + 'px)');
        },
        getDesktopSmallDownQuery: function getDesktopSmallDownQuery() {
            return $window.matchMedia('(max-width: ' + desktopSmallMediaBreakpoint + 'px)');
        },
        // check if size is bigger than the specified one
        getPhonePortraitUpQuery: function getPhonePortraitUpQuery() {
            return $window.matchMedia('(min-width: ' + (phonePortraitMediaBreakpoint + 1) + 'px)');
        },
        getPhoneLandscapeUpQuery: function getPhoneLandscapeUpQuery() {
            return $window.matchMedia('(min-width: ' + (phoneLandscapeMediaBreakpoint + 1) + 'px)');
        },
        getTabletPortraitUpQuery: function getTabletPortraitUpQuery() {
            return $window.matchMedia('(min-width: ' + (tabletPortraitMediaBreakpoint + 1) + 'px)');
        },
        getTabletLandscapeUpQuery: function getTabletLandscapeUpQuery() {
            return $window.matchMedia('(min-width: ' + (tabletLandscapeMediaBreakpoint + 1) + 'px)');
        },
        getDesktopSmallUpQuery: function getDesktopSmallUpQuery() {
            return $window.matchMedia('(min-width: ' + (desktopSmallMediaBreakpoint + 1) + 'px)');
        }
    };
};
fn.$inject = ['$window', 'phonePortraitMediaBreakpoint', 'phoneLandscapeMediaBreakpoint', 'tabletPortraitMediaBreakpoint', 'tabletLandscapeMediaBreakpoint', 'desktopSmallMediaBreakpoint'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-util-angular/MediaQueriesUtil.js
// module id = 928
// module chunks = 0